import React from "react";
import { AutoComplete } from "antd";

// Pick a predefined option or type a custom one. Works inside Form.Item
// (value/onChange are injected); the typed text is the saved value.
// `options` is [{ value, label }].
const CustomReasonInput = ({ value, onChange, options = [], ...rest }) => {
  const typed = (value || "").trim().toLowerCase();
  const matches = options.filter(o => (o.label ?? "").toLowerCase().includes(typed));
  const isExact = options.some(
    o => (o.label ?? "").toLowerCase() === typed || String(o.value).toLowerCase() === typed
  );
  // Typed text that matches nothing is offered as its own plain option.
  const shown = typed && !isExact ? [{ value: value.trim(), label: value.trim() }, ...matches] : matches;

  return (
    <AutoComplete
      allowClear
      style={{ width: "100%" }}
      placeholder="Select or type your own"
      options={shown}
      value={value}
      onChange={onChange}
      filterOption={false}
      {...rest}
    />
  );
};

export default CustomReasonInput;
